<div *ngIf="alert" class="fixed inset-x-0 top-5 flex justify-center z-[99999]">
  <div
    [ngClass]="{
      'bg-blue-600': alert.type === 'success',
      'bg-red-600': alert.type === 'error',
      'bg-yellow-500': alert.type === 'warning',
      'alert-animation': true
    }"
    class="text-white px-6 py-4 rounded shadow-lg max-w-sm w-full text-center"
  >
    {{ alert.message }}
  </div>
</div>
